// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1292":"abd52210","5559":"6b7dfe58"}[chunkId] + ".chunk.css";
};